// extracted by css-extract-rspack-plugin
export default {"cls1":"useAttachment-cls1_yJY","cls2":"useAttachment-cls2_04X useAttachment-cls1_yJY"};